import { render } from "./withdrawUSer.vue?vue&type=template&id=5965a530&scoped=true"
import script from "./withdrawUSer.vue?vue&type=script&lang=js"
export * from "./withdrawUSer.vue?vue&type=script&lang=js"

import "./withdrawUSer.vue?vue&type=style&index=0&id=5965a530&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5965a530"]])

export default __exports__